var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeoInsuranceBrokingLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 72,
    viewBox: "0 0 232 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 14.5583H91.1752V32.3999H88V14.5583Z",
    fill: "#162E6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0893 14.5583H99.2977L107.941 27.8135H107.992V14.5583H111.167V32.3999H107.135L98.3149 18.7163H98.2645V32.3999H95.0893V14.5583Z",
    fill: "#162E6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.89 18.3887C123.554 17.9015 123.101 17.5487 122.53 17.3303C121.975 17.0951 121.387 16.9775 120.766 16.9775C120.396 16.9775 120.035 17.0195 119.682 17.1035C119.346 17.1875 119.035 17.3219 118.75 17.5067C118.481 17.6915 118.262 17.9351 118.094 18.2375C117.926 18.5231 117.842 18.8675 117.842 19.2707C117.842 19.8755 118.052 20.3375 118.472 20.6567C118.892 20.9759 119.413 21.2531 120.035 21.4883C120.656 21.7235 121.337 21.9503 122.076 22.1687C122.815 22.3871 123.496 22.6895 124.117 23.0759C124.739 23.4623 125.26 23.9747 125.68 24.6131C126.1 25.2515 126.31 26.0999 126.31 27.1583C126.31 28.1159 126.133 28.9559 125.78 29.6783C125.428 30.3839 124.949 30.9719 124.344 31.4423C123.756 31.9127 123.067 32.2655 122.278 32.5007C121.488 32.7359 120.656 32.8535 119.783 32.8535C118.674 32.8535 117.607 32.6687 116.582 32.2991C115.558 31.9295 114.676 31.3079 113.936 30.4343L116.33 28.1159C116.717 28.7039 117.221 29.1659 117.842 29.5019C118.481 29.8211 119.153 29.9807 119.858 29.9807C120.228 29.9807 120.598 29.9303 120.967 29.8295C121.337 29.7287 121.673 29.5775 121.975 29.3759C122.278 29.1743 122.521 28.9223 122.706 28.6199C122.891 28.3007 122.983 27.9395 122.983 27.5363C122.983 26.8811 122.773 26.3771 122.353 26.0243C121.933 25.6715 121.412 25.3775 120.791 25.1423C120.169 24.8903 119.489 24.6551 118.75 24.4367C118.01 24.2183 117.33 23.9243 116.708 23.5547C116.087 23.1683 115.566 22.6643 115.146 22.0427C114.726 21.4043 114.516 20.5559 114.516 19.4975C114.516 18.5735 114.701 17.7755 115.07 17.1035C115.457 16.4315 115.952 15.8771 116.557 15.4403C117.179 14.9867 117.884 14.6507 118.674 14.4323C119.464 14.2139 120.27 14.1047 121.093 14.1047C122.034 14.1047 122.941 14.2475 123.815 14.5331C124.705 14.8187 125.503 15.2891 126.209 15.9443L123.89 18.3887Z",
    fill: "#162E6A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.905 25.8479C143.905 26.9231 143.72 27.8975 143.35 28.7711C142.981 29.6279 142.477 30.3587 141.838 30.9635C141.2 31.5683 140.444 32.0387 139.57 32.3747C138.697 32.6939 137.747 32.8535 136.723 32.8535C135.698 32.8535 134.749 32.6939 133.875 32.3747C133.001 32.0387 132.237 31.5683 131.582 30.9635C130.943 30.3587 130.439 29.6279 130.07 28.7711C129.717 27.8975 129.541 26.9231 129.541 25.8479V14.5583H132.716V25.7471C132.716 26.1839 132.783 26.6459 132.917 27.1331C133.052 27.6035 133.27 28.0403 133.573 28.4435C133.892 28.8467 134.303 29.1827 134.807 29.4515C135.328 29.7035 135.967 29.8295 136.723 29.8295C137.479 29.8295 138.109 29.7035 138.613 29.4515C139.133 29.1827 139.545 28.8467 139.847 28.4435C140.167 28.0403 140.393 27.6035 140.528 27.1331C140.662 26.6459 140.729 26.1839 140.729 25.7471V14.5583H143.905V25.8479Z",
    fill: "#162E6A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.803 14.5583H154.002C154.859 14.5583 155.682 14.6423 156.471 14.8103C157.278 14.9615 157.992 15.2303 158.613 15.6167C159.235 16.0031 159.731 16.5239 160.1 17.1791C160.47 17.8343 160.655 18.6659 160.655 19.6739C160.655 20.9675 160.293 22.0511 159.571 22.9247C158.865 23.7983 157.849 24.3275 156.522 24.5123L161.259 32.3999H157.429L153.296 24.8399H150.978V32.3999H147.803V14.5583ZM153.447 22.1183C153.901 22.1183 154.355 22.1015 154.808 22.0679C155.262 22.0175 155.673 21.9167 156.043 21.7655C156.429 21.5975 156.74 21.3539 156.975 21.0347C157.211 20.6987 157.328 20.2367 157.328 19.6487C157.328 19.1279 157.219 18.7079 157.001 18.3887C156.782 18.0695 156.497 17.8343 156.144 17.6831C155.791 17.5151 155.396 17.4059 154.959 17.3555C154.539 17.3051 154.128 17.2799 153.725 17.2799H150.978V22.1183H153.447Z",
    fill: "#162E6A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.446 14.5583H172.193L179.879 32.3999H176.25L174.587 28.3175H166.851L165.238 32.3999H161.685L169.446 14.5583ZM173.478 25.5959L170.732 18.3383L167.934 25.5959H173.478Z",
    fill: "#162E6A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M181.862 14.5583H186.07L194.714 27.8135H194.764V14.5583H197.94V32.3999H193.908L185.088 18.7163H185.037V32.3999H181.862V14.5583Z",
    fill: "#162E6A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M214.166 18.7415C213.511 18.0359 212.872 17.5655 212.251 17.3303C211.646 17.0951 211.033 16.9775 210.411 16.9775C209.487 16.9775 208.647 17.1455 207.891 17.4815C207.152 17.8007 206.513 18.2543 205.976 18.8423C205.438 19.4135 205.018 20.0855 204.716 20.8583C204.43 21.6311 204.287 22.4627 204.287 23.3531C204.287 24.3107 204.43 25.1927 204.716 25.9991C205.018 26.8055 205.438 27.5027 205.976 28.0907C206.513 28.6787 207.152 29.1407 207.891 29.4767C208.647 29.8127 209.487 29.9807 210.411 29.9807C211.133 29.9807 211.831 29.8127 212.503 29.4767C213.191 29.1239 213.83 28.5695 214.418 27.8135L217.039 29.6783C216.232 30.7871 215.249 31.5935 214.09 32.0975C212.931 32.6015 211.696 32.8535 210.386 32.8535C209.008 32.8535 207.74 32.6351 206.581 32.1983C205.438 31.7447 204.447 31.1147 203.607 30.3083C202.784 29.4851 202.137 28.5023 201.667 27.3599C201.196 26.2175 200.961 24.9491 200.961 23.5547C200.961 22.1267 201.196 20.8331 201.667 19.6739C202.137 18.4979 202.784 17.4983 203.607 16.6751C204.447 15.8519 205.438 15.2219 206.581 14.7851C207.74 14.3315 209.008 14.1047 210.386 14.1047C211.595 14.1047 212.713 14.3231 213.737 14.7599C214.779 15.1799 215.745 15.9023 216.635 16.9271L214.166 18.7415Z",
    fill: "#162E6A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.17 14.5583H230.989V17.4311H222.345V21.8159H230.535V24.6887H222.345V29.5271H231.442V32.3999H219.17V14.5583Z",
    fill: "#162E6A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3024 39.7583H93.7456C94.4848 39.7583 95.2072 39.8339 95.9128 39.9851C96.6184 40.1363 97.2484 40.3883 97.8028 40.7411C98.3572 41.0771 98.8024 41.5223 99.1384 42.0767C99.4912 42.6311 99.6676 43.3199 99.6676 44.1431C99.6676 45.1847 99.382 46.0499 98.8108 46.7387C98.2564 47.4107 97.5004 47.8895 96.5428 48.1751V48.2255C97.114 48.2759 97.6432 48.4271 98.1304 48.6791C98.6344 48.9143 99.0628 49.2251 99.4156 49.6115C99.7852 49.9979 100.071 50.4515 100.272 50.9723C100.474 51.4763 100.575 52.0223 100.575 52.6103C100.575 53.6015 100.365 54.4163 99.9448 55.0547C99.5416 55.6931 99.004 56.2055 98.332 56.5919C97.6768 56.9615 96.9292 57.2219 96.0892 57.3731C95.266 57.5243 94.4428 57.5999 93.6196 57.5999H88.3024V39.7583ZM90.4192 47.3183H93.3424C93.8464 47.3183 94.3336 47.2847 94.804 47.2175C95.2912 47.1503 95.728 47.0159 96.1144 46.8143C96.5008 46.5959 96.8116 46.3019 97.0468 45.9323C97.282 45.5459 97.3996 45.0419 97.3996 44.4203C97.3996 43.8659 97.2904 43.4207 97.072 43.0847C96.8536 42.7319 96.5596 42.4547 96.19 42.2531C95.8372 42.0515 95.4256 41.9171 94.9552 41.8499C94.5016 41.7659 94.0396 41.7239 93.5692 41.7239H90.4192V47.3183ZM90.4192 55.6343H93.9976C94.5184 55.6343 95.0308 55.5839 95.5348 55.4831C96.0556 55.3655 96.5176 55.1891 96.9208 54.9539C97.3408 54.7019 97.6768 54.3827 97.9288 53.9963C98.1808 53.5931 98.3068 53.1059 98.3068 52.5347C98.3068 51.9131 98.1808 51.3923 97.9288 50.9723C97.6936 50.5523 97.3744 50.2163 96.9712 49.9643C96.5848 49.7123 96.1312 49.5359 95.6104 49.4351C95.1064 49.3343 94.5856 49.2839 94.048 49.2839H90.4192V55.6343Z",
    fill: "#162E6A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.175 39.7583H108.737C109.593 39.7583 110.442 39.8087 111.282 39.9095C112.139 40.0103 112.903 40.2287 113.575 40.5647C114.247 40.9007 114.793 41.3963 115.213 42.0515C115.633 42.6899 115.843 43.5635 115.843 44.6723C115.843 45.9827 115.448 47.0411 114.659 47.8475C113.869 48.6539 112.777 49.1663 111.383 49.3847L116.448 57.5999H113.852L109.014 49.5863H106.292V57.5999H104.175V39.7583ZM106.292 47.6207H108.182C108.77 47.6207 109.375 47.6039 109.997 47.5703C110.635 47.5367 111.215 47.4275 111.735 47.2427C112.273 47.0579 112.71 46.7723 113.046 46.3859C113.399 45.9827 113.575 45.4115 113.575 44.6723C113.575 44.0339 113.449 43.5215 113.197 43.1351C112.945 42.7487 112.609 42.4547 112.189 42.2531C111.786 42.0347 111.324 41.8919 110.803 41.8247C110.299 41.7575 109.787 41.7239 109.266 41.7239H106.292V47.6207Z",
    fill: "#162E6A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.872 58.0535C126.511 58.0535 125.259 57.8183 124.117 57.3479C122.991 56.8775 122.009 56.2307 121.169 55.4075C120.345 54.5675 119.699 53.5763 119.228 52.4339C118.775 51.2747 118.548 50.0231 118.548 48.6791C118.548 47.3351 118.775 46.0919 119.228 44.9495C119.699 43.7903 120.345 42.7991 121.169 41.9759C122.009 41.1359 122.991 40.4807 124.117 40.0103C125.259 39.5399 126.511 39.3047 127.872 39.3047C129.233 39.3047 130.476 39.5399 131.601 40.0103C132.744 40.4807 133.727 41.1359 134.55 41.9759C135.39 42.7991 136.037 43.7903 136.49 44.9495C136.961 46.0919 137.196 47.3351 137.196 48.6791C137.196 50.0231 136.961 51.2747 136.49 52.4339C136.037 53.5763 135.39 54.5675 134.55 55.4075C133.727 56.2307 132.744 56.8775 131.601 57.3479C130.476 57.8183 129.233 58.0535 127.872 58.0535ZM127.872 56.0879C128.913 56.0879 129.863 55.8947 130.719 55.5083C131.593 55.1219 132.341 54.5927 132.962 53.9207C133.584 53.2487 134.063 52.4675 134.399 51.5771C134.751 50.6699 134.928 49.7039 134.928 48.6791C134.928 47.6543 134.751 46.6967 134.399 45.8063C134.063 44.8991 133.584 44.1095 132.962 43.4375C132.341 42.7655 131.593 42.2363 130.719 41.8499C129.863 41.4635 128.913 41.2703 127.872 41.2703C126.83 41.2703 125.873 41.4635 124.999 41.8499C124.142 42.2363 123.403 42.7655 122.781 43.4375C122.16 44.1095 121.673 44.8991 121.32 45.8063C120.984 46.6967 120.816 47.6543 120.816 48.6791C120.816 49.7039 120.984 50.6699 121.32 51.5771C121.673 52.4675 122.16 53.2487 122.781 53.9207C123.403 54.5927 124.142 55.1219 124.999 55.5083C125.873 55.8947 126.83 56.0879 127.872 56.0879Z",
    fill: "#162E6A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140.597 39.7583H142.714V47.4695H143.017L151.131 39.7583H154.18L145.36 47.8979L154.609 57.5999H151.509L143.017 48.5279H142.714V57.5999H140.597V39.7583Z",
    fill: "#162E6A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M156.47 39.7583H158.587V57.5999H156.47V39.7583Z",
    fill: "#162E6A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M163.016 39.7583H165.688L176.02 54.5759H176.07V39.7583H178.187V57.5999H175.516L165.184 42.7823H165.133V57.5999H163.016V39.7583Z",
    fill: "#162E6A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M197.801 56.3903C196.776 56.9615 195.692 57.3815 194.55 57.6503C193.424 57.9191 192.282 58.0535 191.123 58.0535C189.728 58.0535 188.451 57.8267 187.292 57.3731C186.133 56.9195 185.125 56.2811 184.268 55.4579C183.428 54.6347 182.773 53.6519 182.303 52.5095C181.832 51.3503 181.597 50.0735 181.597 48.6791C181.597 47.2679 181.841 45.9911 182.328 44.8487C182.832 43.6895 183.521 42.7067 184.394 41.9003C185.268 41.0771 186.284 40.4387 187.443 39.9851C188.603 39.5315 189.854 39.3047 191.198 39.3047C192.374 39.3047 193.5 39.4811 194.575 39.8339C195.667 40.1867 196.641 40.7915 197.498 41.6483L195.911 43.3115C195.306 42.6563 194.567 42.1523 193.693 41.7995C192.836 41.4467 191.954 41.2703 191.047 41.2703C190.022 41.2703 189.073 41.4551 188.199 41.8247C187.326 42.1943 186.561 42.7067 185.906 43.3619C185.268 44.0171 184.764 44.7983 184.394 45.7055C184.041 46.6127 183.865 47.6039 183.865 48.6791C183.865 49.7375 184.041 50.7203 184.394 51.6275C184.764 52.5347 185.268 53.3243 185.906 53.9963C186.561 54.6515 187.343 55.1639 188.25 55.5335C189.157 55.9031 190.157 56.0879 191.249 56.0879C191.971 56.0879 192.727 56.0039 193.517 55.8359C194.306 55.6511 195.029 55.3907 195.684 55.0547V49.5863H191.576V47.6207H197.801V56.3903Z",
    fill: "#162E6A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_37_516",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8822 72 72 55.8823 72 36C72 16.1177 55.8822 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_37_516)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2661 37.3806C73.2661 58.0253 56.5302 74.7612 35.8855 74.7612C15.2407 74.7612 -1.49512 58.0253 -1.49512 37.3806C-1.49512 16.7359 15.2407 0 35.8855 0C56.5302 0 73.2661 16.7359 73.2661 37.3806Z",
    fill: "url(#paint0_linear_37_516)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-80.7996 27.367C-80.5754 27.367 -80.3885 27.215 -80.3311 27.0082H-74.1484L-71.624 29.5326H-50.0927L-45.9834 25.4257H-38.7066L-33.7275 30.4048H-25.282L-17.8931 23.0159H1.13611L6.49649 17.6555H8.65459L12.3553 13.9549H19.0514L27.1081 5.89809C27.295 6.00275 27.5368 5.97783 27.6938 5.82083C27.8832 5.62895 27.8832 5.31993 27.6938 5.12805C27.5044 4.93616 27.1929 4.93616 27.001 5.12805C26.8415 5.28754 26.8166 5.52677 26.9237 5.71617L18.9417 13.6957H12.2456L8.54494 17.3964H6.38684L1.02647 22.7567H-18.0027L-25.3917 30.1456H-33.6204L-38.5995 25.164H-46.0905L-50.1974 29.2734H-71.5143L-74.0387 26.749H-80.3287C-80.386 26.5421 -80.5729 26.3901 -80.7972 26.3901C-81.0688 26.3901 -81.2881 26.6094 -81.2881 26.8786C-81.2881 27.1477 -81.0688 27.3695 -80.7972 27.3695L-80.7996 27.367Z",
    fill: "url(#paint1_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-81.6615 51.2083C-81.4372 51.2083 -81.2478 51.0563 -81.1905 50.8495H-71.2522L-69.1589 48.7562H-55.1437L-52.4323 51.4675H-46.1225L-45.0061 50.3536H-35.2746L-30.0862 55.542H-20.0259L-15.5327 51.0488H-6.38942L-0.528137 56.9101H5.42284L10.1179 52.2151H13.4771L20.4324 59.1704H24.4222L29.7227 64.4735C29.6156 64.6604 29.6405 64.9021 29.8025 65.0591C29.9919 65.251 30.3034 65.251 30.4953 65.0591C30.6846 64.8672 30.6846 64.5582 30.4953 64.3663C30.3358 64.2068 30.094 64.1819 29.9096 64.2891L24.5318 58.9112H20.542L13.5868 51.9559H10.0132L5.31818 56.6485H-0.416L-6.27728 50.7872H-15.6374L-20.1305 55.2803H-29.9766L-35.165 50.0919H-45.1132L-46.2296 51.2058H-52.3227L-55.034 48.4945H-69.2636L-71.3569 50.5878H-81.188C-81.2453 50.381 -81.4347 50.229 -81.659 50.229C-81.9281 50.229 -82.1499 50.4483 -82.1499 50.7199C-82.1499 50.9915 -81.9306 51.2083 -81.659 51.2083H-81.6615Z",
    fill: "url(#paint2_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-80.2634 37.061C-80.0391 37.061 -79.8497 36.909 -79.7924 36.7022H-60.6436L-54.9244 42.4214H-47.2464L-42.7881 37.9656H-31.6188L-26.6771 42.9048H-18.5157L-16.6367 41.0258H-9.49449L-6.56884 43.9515H-0.797279L2.35764 40.7966H8.43822L12.6597 45.0181H20.3576L25.8526 50.5105H44.989L49.2379 54.7595C49.1332 54.9464 49.1581 55.1856 49.3151 55.3451C49.507 55.537 49.8185 55.537 50.0079 55.3451C50.1973 55.1532 50.1973 54.8442 50.0079 54.6523C49.8484 54.4928 49.6092 54.4679 49.4223 54.5726L45.0961 50.2464H25.9597L20.4673 44.7514H12.7694L8.54539 40.5299H2.24799L-0.906929 43.6849H-6.46416L-9.38982 40.7592H-16.7463L-18.6253 42.6382H-26.5699L-31.5092 37.699H-42.8953L-47.3535 42.1547H-54.8172L-60.5364 36.4355H-79.7949C-79.8522 36.2287 -80.0391 36.0767 -80.2659 36.0767C-80.5375 36.0767 -80.7568 36.296 -80.7568 36.5651C-80.7568 36.8342 -80.5375 37.056 -80.2659 37.056L-80.2634 37.061Z",
    fill: "url(#paint3_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-71.4638 32.224L-74.3645 29.3257H-79.6875C-79.7448 29.1189 -79.9317 28.9669 -80.1585 28.9669C-80.4301 28.9669 -80.6494 29.1862 -80.6494 29.4553C-80.6494 29.7245 -80.4301 29.9463 -80.1585 29.9463C-79.9342 29.9463 -79.7448 29.7943 -79.6875 29.5874H-74.4716L-71.5709 32.4857H-59.649L-53.4737 38.6609H-48.5868L-44.6943 34.7684H-30.223L-25.8868 39.1045H-19.4823L-16.0109 35.6356H-5.20042L-1.99567 38.8404H11.2321L18.92 31.1524H34.2137L37.1842 28.1819C37.3711 28.2866 37.6103 28.2641 37.7698 28.1047C37.9617 27.9128 37.9617 27.6037 37.7698 27.4119C37.5779 27.22 37.2689 27.22 37.077 27.4119C36.9175 27.5714 36.8926 27.8106 36.9998 27.9975L34.1065 30.8907H18.8129L11.1249 38.5787H-1.88602L-5.09077 35.3739H-16.118L-19.5895 38.8428H-25.7772L-30.1133 34.5067H-44.7989L-48.694 38.3993H-53.3666L-59.5418 32.224H-71.4638Z",
    fill: "url(#paint4_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M35.6884 14.9267H29.1916L24.1378 19.9805H11.5754L5.36775 26.1882H-16.7242L-23.4477 32.9117C-23.6346 32.807 -23.8738 32.832 -24.0333 32.989C-24.2252 33.1808 -24.2252 33.4899 -24.0333 33.6817C-23.8414 33.8736 -23.5324 33.8736 -23.3405 33.6817C-23.1811 33.5223 -23.1586 33.2805 -23.2633 33.0936L-16.617 26.4474H5.47491L11.6826 20.2397H24.2449L29.2988 15.1858H35.7955L40.5603 10.4211H48.7865C48.8439 10.6279 49.0308 10.7799 49.2575 10.7799C49.5292 10.7799 49.7485 10.5606 49.7485 10.2915C49.7485 10.0223 49.5292 9.80054 49.2575 9.80054C49.0333 9.80054 48.8439 9.95255 48.7865 10.1594H40.4507L35.6859 14.9242L35.6884 14.9267Z",
    fill: "url(#paint5_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-2.46664 27.8479H-14.6328L-20.5613 33.7765C-20.7482 33.6718 -20.9875 33.6967 -21.1495 33.8537C-21.3389 34.0456 -21.3389 34.3546 -21.1495 34.5465C-20.9576 34.7384 -20.6461 34.7384 -20.4567 34.5465C-20.2972 34.387 -20.2723 34.1478 -20.3794 33.9609L-14.5256 28.1096H-2.57629L1.06956 31.7554H8.36127L13.759 26.3601H27.2734C27.3307 26.567 27.5201 26.719 27.7443 26.719C28.0135 26.719 28.2328 26.4997 28.2328 26.2281C28.2328 25.9589 28.0135 25.7396 27.7443 25.7396C27.5201 25.7396 27.3307 25.8916 27.2734 26.0985H13.6494L8.25411 31.4937H1.17672L-2.46913 27.8479H-2.46664Z",
    fill: "url(#paint6_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M32.7273 19.3301L28.6129 23.4469H12.0085L6.37645 29.0764H2.77047C2.71315 28.8696 2.52626 28.7176 2.29948 28.7176C2.02785 28.7176 1.81104 28.9369 1.81104 29.2085C1.81104 29.4801 2.02785 29.6969 2.29948 29.6969C2.52626 29.6969 2.71315 29.5449 2.77047 29.3381H6.4861L12.1156 23.7061H28.7201L32.8369 19.5917H38.6857L41.6912 16.5863C41.8781 16.691 42.1173 16.6661 42.2768 16.5091C42.4687 16.3172 42.4687 16.0082 42.2768 15.8163C42.0849 15.6244 41.7759 15.6244 41.584 15.8163C41.4245 15.9758 41.4021 16.215 41.5067 16.4019L38.5786 19.3301H32.7298H32.7273Z",
    fill: "url(#paint7_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M29.2238 29.4355H17.424L10.4936 36.3659H0.0619183L-2.82386 33.4776H-10.5816C-10.6389 33.2708 -10.8258 33.1187 -11.0501 33.1187C-11.3217 33.1187 -11.541 33.338 -11.541 33.6097C-11.541 33.8813 -11.3217 34.0981 -11.0501 34.0981C-10.8258 34.0981 -10.6389 33.9461 -10.5816 33.7393H-2.93102L-0.0427513 36.6275H10.6032L17.5336 29.6972H29.2263C29.2836 29.904 29.4705 30.056 29.6973 30.056C29.9689 30.056 30.1882 29.8367 30.1882 29.5676C30.1882 29.2985 29.9714 29.0767 29.6973 29.0767C29.473 29.0767 29.2861 29.2287 29.2263 29.4355H29.2238Z",
    fill: "url(#paint8_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M42.1849 21.4608C41.9606 21.4608 41.7712 21.6128 41.7139 21.8197H36.9541L30.9258 27.8479H15.5499L9.27002 34.1279H0.859384L-2.89364 30.3723H-12.8169C-12.8742 30.1655 -13.0612 30.0135 -13.2879 30.0135C-13.5571 30.0135 -13.7764 30.2328 -13.7764 30.5044C-13.7764 30.7761 -13.5571 30.9954 -13.2879 30.9954C-13.0612 30.9954 -12.8742 30.8433 -12.8169 30.6365H-3.00079L0.754714 34.3895H9.37966L15.6621 28.1096H31.038L37.0662 22.0813H41.7189C41.7762 22.2882 41.9656 22.4402 42.1899 22.4402C42.459 22.4402 42.6808 22.2209 42.6808 21.9493C42.6808 21.6776 42.4615 21.4608 42.1899 21.4608H42.1849Z",
    fill: "url(#paint9_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M25.3294 11.3506L20.0961 16.5839H11.9372L4.06732 24.4537H-15.7095C-15.7668 24.2469 -15.9537 24.0949 -16.1805 24.0949C-16.4496 24.0949 -16.6689 24.3142 -16.6689 24.5858C-16.6689 24.8549 -16.4496 25.0767 -16.1805 25.0767C-15.9537 25.0767 -15.7668 24.9247 -15.7095 24.7179H4.17697L12.0443 16.848H20.2033L25.4366 11.6147H33.7749L39.0007 6.38893C39.1876 6.4936 39.4294 6.46868 39.5864 6.31168C39.7758 6.11979 39.7758 5.81078 39.5864 5.61889C39.397 5.427 39.0855 5.427 38.8936 5.61889C38.7341 5.77838 38.7092 6.01762 38.8163 6.20701L33.6678 11.3556H25.3294V11.3506Z",
    fill: "url(#paint10_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-64.8376 47.3109C-64.6133 47.3109 -64.4264 47.1589 -64.3691 46.9521H-53.3991L-51.1613 49.1899H-34.0509L-29.6824 53.5585H-21.3814L-15.9114 48.0884H-3.87482L1.04446 53.0077H6.34004L9.94353 49.4017H15.1818L19.8045 54.0245H44.0197C44.077 54.2313 44.2664 54.3833 44.4907 54.3833C44.7623 54.3833 44.9816 54.164 44.9816 53.8924C44.9816 53.6208 44.7623 53.4039 44.4907 53.4039C44.2664 53.4039 44.077 53.556 44.0197 53.7628H19.9117L15.289 49.1401H9.83389L6.23038 52.746H1.14912L-3.76767 47.8268H-16.021L-21.4911 53.2968H-29.5777L-33.9463 48.9282H-51.0566L-53.2969 46.6904H-64.3741C-64.4314 46.4836 -64.6183 46.3315 -64.8426 46.3315C-65.1142 46.3315 -65.3335 46.5508 -65.3335 46.8225C-65.3335 47.0916 -65.1142 47.3109 -64.8426 47.3109H-64.8376Z",
    fill: "url(#paint11_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-12.3203 43.7396H-10.08L-7.68013 46.1395H1.43326L3.62625 43.9465H8.54554L11.1298 46.5332H19.0844L25.1425 52.5914H43.3045C43.3618 52.7982 43.5487 52.9502 43.773 52.9502C44.0446 52.9502 44.2639 52.7309 44.2639 52.4593C44.2639 52.1877 44.0471 51.9684 43.773 51.9684C43.5487 51.9684 43.3618 52.1204 43.3045 52.3272H25.2497L19.1915 46.2691H11.2369L8.6527 43.6848H3.5166L1.32361 45.8778H-7.57546L-9.97529 43.478H-12.43L-14.4136 45.4641H-26.652L-31.6336 40.4825H-40.5476L-44.1561 44.091H-52.0933C-52.1506 43.8842 -52.34 43.7322 -52.5642 43.7322C-52.8334 43.7322 -53.0552 43.9515 -53.0552 44.2231C-53.0552 44.4947 -52.8359 44.7115 -52.5642 44.7115C-52.34 44.7115 -52.1506 44.5595 -52.0933 44.3527H-44.0489L-40.4405 40.7442H-31.7408L-26.7592 45.7258H-14.3065L-12.3203 43.7396Z",
    fill: "url(#paint12_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M35.5066 34.8953L40.3885 30.0134C40.5754 30.1181 40.8172 30.0932 40.9742 29.9362C41.1636 29.7443 41.1636 29.4353 40.9742 29.2434C40.7848 29.0515 40.4708 29.0515 40.2814 29.2434C40.1219 29.4029 40.097 29.6421 40.2016 29.829L35.397 34.6362H18.4312L12.5026 40.5647C12.3157 40.4601 12.074 40.4825 11.9145 40.642C11.7251 40.8339 11.7251 41.1429 11.9145 41.3348C12.1064 41.5267 12.4179 41.5267 12.6073 41.3348C12.7668 41.1753 12.7917 40.9361 12.6845 40.7467L18.5383 34.8929H35.5042L35.5066 34.8953Z",
    fill: "url(#paint13_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M49.0798 46.9071H43.9512L41.5688 44.5247H36.1187L33.375 47.2684H26.5518L21.787 42.5036H14.4629C14.4056 42.2968 14.2187 42.1448 13.9919 42.1448C13.7203 42.1448 13.501 42.3641 13.501 42.6357C13.501 42.9073 13.7203 43.1241 13.9919 43.1241C14.2162 43.1241 14.4056 42.9721 14.4629 42.7653H21.6799L26.4446 47.5301H33.4821L36.2259 44.7863H41.4592L43.8416 47.1687H48.9677L53.4857 51.6843C53.3811 51.8712 53.4035 52.1129 53.563 52.2724C53.7549 52.4643 54.0639 52.4643 54.2558 52.2724C54.4452 52.0805 54.4452 51.7715 54.2558 51.5796C54.0963 51.4201 53.8571 51.3952 53.6677 51.4999L49.0748 46.9071H49.0798Z",
    fill: "url(#paint14_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M25.8699 37.7839L29.3712 41.2852H33.6301L36.9321 37.9832H41.7143L44.169 35.5286C44.3559 35.6332 44.5951 35.6083 44.7546 35.4513C44.944 35.2594 44.944 34.9504 44.7546 34.7585C44.5627 34.5667 44.2537 34.5667 44.0618 34.7585C43.9023 34.918 43.8774 35.1573 43.9821 35.3442L41.6022 37.7241H36.8199L33.5155 41.026H29.4734L25.9721 37.5247H19.438L16.8288 40.1339C16.6419 40.0267 16.4002 40.0516 16.2407 40.2136C16.0513 40.4055 16.0513 40.7145 16.2407 40.9064C16.4326 41.0983 16.7416 41.0983 16.9335 40.9064C17.093 40.7469 17.1154 40.5052 17.0107 40.3183L19.5426 37.7864H25.8599L25.8699 37.7839Z",
    fill: "url(#paint15_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M32.5131 36.1489C32.4558 35.942 32.2689 35.79 32.0446 35.79C31.773 35.79 31.5537 36.0093 31.5537 36.2785C31.5537 36.5501 31.773 36.7694 32.0446 36.7694C32.2689 36.7694 32.4558 36.6174 32.5131 36.4105H39.6927L45.1179 30.9854C45.3048 31.0925 45.5465 31.0676 45.7035 30.9081C45.8954 30.7162 45.8954 30.4072 45.7035 30.2153C45.5141 30.0234 45.2026 30.0234 45.0132 30.2153C44.8537 30.3748 44.8288 30.6141 44.9335 30.801L39.5856 36.1489H32.5131Z",
    fill: "url(#paint16_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M43.631 40.0863H38.4675L35.9779 42.5759H25.9051L23.8118 40.4826H19.8096C19.7523 40.2757 19.5629 40.1237 19.3386 40.1237C19.0694 40.1237 18.8477 40.343 18.8477 40.6147C18.8477 40.8863 19.067 41.1056 19.3386 41.1056C19.5629 41.1056 19.7523 40.9536 19.8096 40.7467H23.7046L25.798 42.8401H36.0876L38.5796 40.3505H43.7406L50.9875 33.1037C51.1744 33.2083 51.4161 33.1859 51.5731 33.0264C51.765 32.8345 51.765 32.5255 51.5731 32.3336C51.3837 32.1417 51.0722 32.1417 50.8803 32.3336C50.7208 32.4931 50.6984 32.7323 50.8031 32.9192L43.6335 40.0913L43.631 40.0863Z",
    fill: "url(#paint17_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M24.305 42.6333C24.1156 42.4414 23.8041 42.4414 23.6147 42.6333C23.4253 42.8252 23.4253 43.1342 23.6147 43.3261C23.7742 43.4856 24.0159 43.5105 24.2003 43.4033L26.2313 45.4343H31.7512C31.8085 45.6412 31.9954 45.7957 32.2197 45.7957C32.4913 45.7957 32.7106 45.5764 32.7106 45.3048C32.7106 45.0331 32.4913 44.8138 32.2197 44.8138C31.9954 44.8138 31.8085 44.9658 31.7512 45.1727H26.341L24.3847 43.2164C24.4894 43.0295 24.4645 42.7903 24.305 42.6308V42.6333Z",
    fill: "url(#paint18_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M49.2575 63.7308C49.0332 63.7308 48.8438 63.8828 48.7865 64.0896H42.0755L40.7048 62.719H32.7627L26.8441 56.7979H20.9629C20.9056 56.5911 20.7162 56.4391 20.4919 56.4391C20.2203 56.4391 20.001 56.6584 20.001 56.9275C20.001 57.1992 20.2203 57.4185 20.4919 57.4185C20.7162 57.4185 20.9056 57.2664 20.9629 57.0596H26.7345L32.6531 62.9807H40.5952L41.9658 64.3538H48.784C48.8413 64.5606 49.0282 64.7127 49.255 64.7127C49.5267 64.7127 49.746 64.4934 49.746 64.2217C49.746 63.9501 49.5267 63.7308 49.255 63.7308H49.2575Z",
    fill: "url(#paint19_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M53.7361 61.022C53.5093 61.022 53.3224 61.174 53.2651 61.3809H42.33L41.1388 60.1897H34.5698L29.4437 55.0636H22.5532C22.4959 54.8567 22.309 54.7047 22.0822 54.7047C21.813 54.7047 21.5938 54.924 21.5938 55.1932C21.5938 55.4648 21.813 55.6841 22.0822 55.6841C22.309 55.6841 22.4959 55.5321 22.5532 55.3252H29.3365L34.4626 60.4514H41.0317L42.2229 61.6426H53.2651C53.3224 61.8494 53.5093 62.0014 53.7361 62.0014C54.0077 62.0014 54.2245 61.7821 54.2245 61.5105C54.2245 61.2388 54.0052 61.0195 53.7361 61.0195V61.022Z",
    fill: "url(#paint20_linear_37_516)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M46.0234 60.1051C46.2128 60.297 46.5243 60.297 46.7162 60.1051C46.9081 59.9132 46.9081 59.6042 46.7162 59.4123C46.5567 59.2528 46.315 59.2279 46.128 59.3351L43.0155 56.2225H35.2578C35.2005 56.0157 35.0136 55.8636 34.7868 55.8636C34.5151 55.8636 34.2983 56.0829 34.2983 56.3546C34.2983 56.6262 34.5176 56.8455 34.7868 56.8455C35.0111 56.8455 35.2005 56.6935 35.2578 56.4867H42.9083L45.9436 59.5245C45.839 59.7114 45.8639 59.9506 46.0209 60.1101L46.0234 60.1051Z",
    fill: "url(#paint21_linear_37_516)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_37_516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5595 28.2372C24.2876 28.2372 27.3105 31.2575 27.3105 34.9831V43.7601H24.0883V34.9831C24.0883 33.0393 22.5058 31.4569 20.5595 31.4569C18.6132 31.4569 17.0308 33.0393 17.0308 34.9831V43.7601H13.8086V34.9831C13.8086 31.2575 16.8314 28.2372 20.5595 28.2372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9995 31.4594C34.5741 31.4594 33.3455 32.3092 32.7873 33.5253H39.2093C38.6535 32.3067 37.4225 31.4594 35.997 31.4594H35.9995ZM35.9995 28.2372C39.7276 28.2372 42.7505 31.2575 42.7505 34.9831V36.7724H32.4708V37.0141C32.4708 38.9554 34.0557 40.5379 35.9995 40.5379C37.4424 40.5379 38.6859 39.6657 39.2317 38.4222H42.6009C41.9505 41.4724 39.2417 43.7576 35.997 43.7576C32.2689 43.7576 29.2461 40.7373 29.2461 37.0117V34.9831C29.2461 31.2575 32.2689 28.2372 35.997 28.2372H35.9995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9151 37.0141C47.9151 38.9579 49.4975 40.5404 51.4438 40.5404C53.3901 40.5404 54.9725 38.9579 54.9725 37.0141V34.9856C54.9725 33.0418 53.3901 31.4594 51.4438 31.4594C49.4975 31.4594 47.9151 33.0418 47.9151 34.9856V37.0141ZM51.4438 28.2372C55.1719 28.2372 58.1947 31.2575 58.1947 34.9831V37.0117C58.1947 40.7397 55.1719 43.7576 51.4438 43.7576C47.7157 43.7576 44.6929 40.7373 44.6929 37.0117V34.9831C44.6929 31.2575 47.7157 28.2372 51.4438 28.2372Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37_516",
    x: -26.1914,
    y: -7.76282,
    width: 124.386,
    height: 95.5229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37_516"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37_516",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_516",
    x1: 105.787,
    y1: 37.3806,
    x2: -1.49512,
    y2: 37.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E0F54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19032F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_37_516",
    x1: 27.8196,
    y1: 17.6818,
    x2: -94.1039,
    y2: 17.6818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_37_516",
    x1: 30.6205,
    y1: 56.8404,
    x2: -95.3959,
    y2: 56.8404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_37_516",
    x1: 50.1305,
    y1: 45.7732,
    x2: -96.1309,
    y2: 45.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_37_516",
    x1: 37.8961,
    y1: 33.1803,
    x2: -94.5738,
    y2: 33.1803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_37_516",
    x1: 49.7375,
    y1: 21.8012,
    x2: -32.8593,
    y2: 21.8012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_37_516",
    x1: 28.2254,
    y1: 30.2106,
    x2: -27.1078,
    y2: 30.2106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_37_516",
    x1: 42.4146,
    y1: 22.6777,
    x2: -2.95827,
    y2: 22.6777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_37_516",
    x1: 30.182,
    y1: 32.8483,
    x2: -16.4418,
    y2: 32.8483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_37_516",
    x1: 42.6724,
    y1: 27.9187,
    x2: -20.4068,
    y2: 27.9187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_37_516",
    x1: 39.72,
    y1: 15.2661,
    x2: -23.2924,
    y2: 15.2661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_37_516",
    x1: 44.9652,
    y1: 50.3534,
    x2: -78.2892,
    y2: 50.3534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_37_516",
    x1: 44.2495,
    y1: 46.7102,
    x2: -64.4846,
    y2: 46.7102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_37_516",
    x1: 41.1119,
    y1: 35.2829,
    x2: 8.32625,
    y2: 35.2829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_37_516",
    x1: 54.3918,
    y1: 47.2754,
    x2: 8.69794,
    y2: 47.2754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_37_516",
    x1: 44.8924,
    y1: 37.9466,
    x2: 12.7165,
    y2: 37.9466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_37_516",
    x1: 45.8453,
    y1: 33.4171,
    x2: 29.875,
    y2: 33.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_37_516",
    x1: 51.7121,
    y1: 37.5096,
    x2: 14.9874,
    y2: 37.5096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_37_516",
    x1: 32.7093,
    y1: 44.1409,
    x2: 22.3877,
    y2: 44.1409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_37_516",
    x1: 49.7415,
    y1: 60.5718,
    x2: 16.5076,
    y2: 60.5718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_37_516",
    x1: 54.2197,
    y1: 58.3494,
    x2: 17.7615,
    y2: 58.3494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_37_516",
    x1: 46.8582,
    y1: 58.0541,
    x2: 32.8231,
    y2: 58.0541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A1D57"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeoInsuranceBrokingLogo);
export default __webpack_public_path__ + "static/media/neoInsuranceBrokingLogo.a075b7f56f1a13d2cc2ed27822a8f9af.svg";
export { ForwardRef as ReactComponent };